import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Cards.css';

function GridSection() {
    const navigate = useNavigate();

    const items = [
        {
            id: 1,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/1400/3f5e89199429495.6680d899f0794.jpg',
            name: 'Cerej',
            path: '/Cerej'
        },
        {
            id: 2,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/4c3209189010149.65f1fe8a77faa.png',
            name: 'Centro de Convivência',
            path: '/centro-de-convivencia'
        },
        {
            id: 3,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/04e98e183752027.65a1776e16674.png',
            name: 'Doce Venttura',
            path: '/doce-venttura'
        },
        {
            id: 4,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/1400/d2e87a162917589.63dd232ba46a0.png',
            name: 'Quadronizei',
            path: '/quadronizei'
        },
        {
            id: 5,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/bd2cc7160757857.63b9ffee2b5f4.png',
            name: 'Biruta Hamburgueria',
            path: '/biruta-hamburgueria'
        },
        {
            id: 6,
            imageUrl: 'https://mir-s3-cdn-cf.behance.net/project_modules/max_1200/30df81158491985.638e48eb9ac21.png',
            name: 'Editora Iluminada',
            path: '/editora-iluminada'
        }
    ];

    const handleCardClick = (path) => {
        navigate(path);
    };

    return (
        <section className="grid-section">
            <div className="grid-container">
                {items.map((item) => (
                    <div key={item.id} className="grid-item" onClick={() => handleCardClick(item.path)}>
                        <img src={item.imageUrl} alt={item.name} className="grid-item-image" />
                        <div className="overlay">
                            <h3>{item.name}</h3>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}

export default GridSection;
